import { useCallback, useState } from "react"
import { PersonEntity } from "../../Objects/Person/PersonEntity"
import { EGenderType } from "../../Enum/EGenderType"
import { CPF_DIGITS_LENGTH, normalizeCpf } from "../../utils/documentFormat"

export const useCreatePerson = () => {
  const [name, setName] = useState("")

  const [cpf, setCpf] = useState("")

  const [rg, setRg] = useState("")

  const [phone, setPhone] = useState("")

  const [email, setEmail] = useState("")

  const [dateBorn, setDateBorn] = useState("")

  const [gender, setGender] = useState<EGenderType>(EGenderType.Man)

  const [person, setPerson] = useState<PersonEntity | null>(null)

  const handleNameChange = (e: React.ChangeEvent<HTMLInputElement>) => setName(e.target.value)
  const handleCpfChange = (e: React.ChangeEvent<HTMLInputElement>) => setCpf(normalizeCpf(e.target.value))
  const handleRgChange = (e: React.ChangeEvent<HTMLInputElement>) => setRg(e.target.value)
  const handlePhoneChange = (e: React.ChangeEvent<HTMLInputElement>) => setPhone(e.target.value)
  const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => setEmail(e.target.value)
  const handleDateBornChange = (e: React.ChangeEvent<HTMLInputElement>) => setDateBorn(e.target.value)
  const handleGenderChange = (e: React.ChangeEvent<HTMLSelectElement>) =>
    setGender(e.target.selectedIndex as EGenderType)

  const handleInitialValue = useCallback((person: PersonEntity | null | undefined) => {
    if (person) {
      setPerson(person)
      setName(person.name)
      setCpf(normalizeCpf(person.cpf))
      setRg(person.rg)
      setPhone(person.phone)
      setEmail(person.email)
      setGender(person.genderType)
      setDateBorn(person.birthDate)
    }
  }, [])

  const handleSubmitForm = () => {
    const normalizedCpf = normalizeCpf(cpf)

    if (name.length === 0 || normalizedCpf.length !== CPF_DIGITS_LENGTH) return null

    return new PersonEntity({
      id: person?.id,
      name: name,
      cpf: normalizedCpf,
      rg: rg,
      phone: phone,
      email: email,
      birthDate: dateBorn,
      genderType: gender,
    })
  }

  return {
    name,
    cpf,
    rg,
    phone,
    email,
    dateBorn,
    gender,
    setCpf,
    setPhone,
    setGender,
    handleNameChange,
    handleCpfChange,
    handleRgChange,
    handlePhoneChange,
    handleEmailChange,
    handleDateBornChange,
    handleGenderChange,
    handleSubmitForm,
    handleInitialValue,
  }
}
